import styled from 'styled-components'

import { mainColors, rgba, shadowColors, XLBold } from '@avantstay/backoffice-core'

export const SelectWrapper = styled.div`
  min-width: 155px;
`

export const MenuContainer = styled.div`
  width: 480px;
  height: 100%;
  max-height: 572px;
  display: flex;
  flex-direction: column;
  gap: 26px;
  background: ${mainColors.white};
  border-radius: 2px;
  box-shadow: 0 4px 16px 0 ${rgba(shadowColors.blur, 0.7)};
  padding: 30px 0;

  > * {
    padding: 0 24px;
  }
`

export const MenuTitle = styled(XLBold)`
  text-align: center;
  line-height: 24px;
`

export const MenuContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: hidden;
`
